import React from "react";
import { modal } from "../modal";

export const modal_simulator = props => {
  return (
    <div className="modal_simulator modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="simulator_step">
        <div className="sp">
          <img
            src="resource/img/static/simulator/sp_modal_step1.png"
            alt="STEP1"
          />
          <img
            src="resource/img/static/simulator/sp_modal_step2.png"
            alt="STEP2"
          />
          <img
            src="resource/img/static/simulator/sp_modal_step3.png"
            alt="STEP3"
          />
        </div>
        <div className="pc">
          <img
            src="resource/img/static/simulator/pc_modal_step1.png"
            alt="STEP1"
          />
          <img
            src="resource/img/static/simulator/pc_modal_step2.png"
            alt="STEP2"
          />
          <img
            src="resource/img/static/simulator/pc_modal_step3.png"
            alt="STEP3"
          />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_simulator.jsx